import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useState} from 'react'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Avatar, Button, Input} from "antd";
import {getFullAddress, renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash";
import Translate from "../../../../modules/local/Translate";
import {compose, mapProps, pure, withProps} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {createControlledFormField} from "../../factory/createFormField";
import {Formik} from "formik";
import FormActionBar from "../../../../components/form/FormActionBar";
import {createSlateTab, Field, FormActions, Section} from "components/form/ModernForm";
import {NullAsDefault, shallowDiff} from 'views/Shared'
import SlateEditor, {SlateRenderer} from "../../../SlateEditor";
import {ModalEditorToolbar} from "../../../SlateEditor/SlateEditor";
import LookupField from "../../../../components/LookupField";
import {CountryPicker} from "../../User/functions/renderLocationCascade";
import {getType} from "../../../../apis/model/base";
import {SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {RiMapPinFill, RiShareForwardFill, RiUser2Fill} from "react-icons/ri";
import {convertFromString, convertToString} from "../../../SlateEditor/functions";
import {FaDirections, FaPhoneAlt} from "react-icons/fa";
import {FaEnvelope, FaIdCard, FaUserTie} from "react-icons/fa6";
import {IoBookOutline, IoPricetagOutline} from "react-icons/io5";
import getTitle from "../../../../helpers/getTitle";
import {MdContactPhone, MdContentCopy} from "react-icons/md";
import getAvatar from "../../../../helpers/getAvatar";
import {useAppConfig} from "../../../../modules/local/AppConfigContext";
import {BiSolidChurch, BiSolidEdit} from "react-icons/bi";
import {LookupTagsPicker} from "../../custom/TagsPicker";
import {API_ROOT_URL} from "../../../../envs/_current/config";
import {baseItemSchema} from "../../../../apis/schema";
import {createListTransform} from "../../../../apis/utils/createListTransform";
import {createValue} from "../../../../components/form/utils";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {SiOpenstreetmap} from "react-icons/si";
import {EnvironmentOutlined} from "@ant-design/icons";
import preventParentEvent from "../../../../helpers/preventParentEvent";
import {BsTrash} from "react-icons/bs";
import {LeafletMap} from "../../../Organization/Settings/Locations/components/LeafletMap";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {ItemInfoWithIcon} from "../../../../components/common/ItemInfoWithIcon";
import EmptyHolder from "../../../../components/EmptyHolder";
import {isRawContentEmpty} from "../../../SlateEditor/functions/parseRawContent";
import {callNativeShare, copyLink} from "../../../../helpers/share";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {yellowPage_editYellowPage_Api} from "../../../../apis";
import {notifyOnError} from "../../factory/createErrorEvent";


const withEditOptional =
    (field_names = []) =>
        ({form, onChange}) => {
            const {user} = form?.values ?? {}
            const locked = Boolean(
                user &&
                _.some(Array.from(field_names ?? []).map((name) => _.get(user, name, null) !== null))
            )
            if (locked) {
                return {
                    // disabled: true,
                    readOnly: true,
                    onChange: undefined,
                }
            } else {
                return {
                    onChange,
                }
            }
        }

const formSchema = {
    owner: {
        title: 'organization interlinkages',
        children: [
            {
                name: 'owner',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('organization interlinkages')}
                                    createIfNotExists={false}
                                    defaultValue={values?.owner?.title}
                                    apiPath={`/lookup/organization/get-by-types`}
                                    name={name}
                                    placeholder={t('click to select')}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        const {org_types = {}} = useAppConfig('org_types')
                                        const org_type = _.get(org_types, _.get(o, 'org_type', '900'))
                                        return (
                                            <div key={i} className="flex items-center gap-3 flex-1 py-2">
                                                <Avatar
                                                    size={40}
                                                    src={getAvatar(o)}
                                                    icon={<BiSolidChurch size={18} className="text-color-500"/>}
                                                    className="flex flex-center background-200 rounded-md"
                                                />
                                                <div className="flex flex-col flex-1">
                                                    <div className="font-bold text-sm text-color-000 leading-snug">
                                                        {o.label}
                                                    </div>
                                                    <div
                                                        className="font-normal text-xs text-green-300 italic leading-tight">
                                                        {t(org_type)}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            owner: e.target,
                                            owner_type: getType(e.target),
                                            owner_id: e.target.id
                                        })
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ]
    },
    location: {
        children: [
            {
                label: 'country',
                name: 'country_id',
                component: compose(
                    withProps({
                        withChangedValues: (values) => ({
                            province_name: undefined,
                            province_id: undefined,
                        }),
                    })
                )(CountryPicker),
            },
            {
                label: 'province',
                name: 'province',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose province')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.province_name}
                                    selectedOption={form?.values?.province}
                                    apiPath={`/lookup/province/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <div className="p-2 font-bold text-sm text-color-000 leading-tight">
                                                {o.location_name}
                                            </div>
                                        </div>
                                    )}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            province: e.target,
                                            province_id: e.target.id,
                                            province_name: e.target.value
                                        })
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    role_title: {
        children: [
            {
                label: 'role title',
                name: 'organization_role_title',
                type: 'text',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}, ...props) => {
                        return ({
                            name,
                            defaultValue: value,
                            onChange,
                            placeholder: translate('role title placeholder'),
                            ...props
                        })
                    }),
                    pure
                )(Input),
            }
        ]
    },
    full_name: {
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>

                                    <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <Avatar
                                                size={50}
                                                src={o.avatar}
                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                icon={<SaintsOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                            />
                                            <div className="flex flex-col flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                {renderIf(
                                                    o?.description,
                                                    <span className="text-xs text-color-400 italic max-lines-1">
                                                        {o?.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'full name',
                name: 'contact_user',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    withAlias={true}
                                    title={t('choose user account')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.contact_name}
                                    selectedOption={form?.values?.contact_user}
                                    apiPath={`/lookup/user/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.cover_photo}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<RiUser2Fill className="text-color-400"/>}
                                                />
                                                <div className="flex flex-col">
                                                    <div className="font-bold text-sm text-color-000 leading-snug">
                                                        {renderIf(
                                                            o?.patron_saint_name,
                                                            <span
                                                                className="mr-1 font-semibold text-color-200 italic">{o?.patron_saint_name}</span>
                                                        )}
                                                        {o.label}
                                                    </div>
                                                    <span className="text-xs text-color-500 italic leading-snug">
                                                  {o?.email}
                                                </span>
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        if (e.target.id) {
                                            form.setValues({
                                                ...form.values,
                                                patron_saint: e.target.patron_saint || form.values.patron_saint || null,
                                                patron_saint_name: e.target.patron_saint_name || form.values.patron_saint_name || null,
                                                patron_saint_id: e.target.patron_saint?.id || form.values.patron_saint?.id || null,
                                                contact_user: e.target,
                                                contact_name: e.target.value,
                                                contact_user_id: e.target.id
                                            })
                                        } else {
                                            form.setValues({
                                                ...form.values,
                                                contact_user: e.target,
                                                contact_name: e.target.value,
                                                contact_user_id: e.target.id
                                            })
                                        }
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    phone_email: {
        children: [
            {
                label: 'phone',
                name: 'phone',
                component: ({name, form, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                {...{
                                    name,
                                    value,
                                    onChange,
                                }}
                                type="tel"
                                inputMode="tel"
                                placeholder={t('ex: phone')}
                                {...(withEditOptional(['phone_number', 'phone2_number'])({
                                    form,
                                    onChange,
                                }) ?? {})}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'email',
                name: 'email',
                component: ({name, form, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                {...{
                                    name,
                                    value,
                                    onChange,
                                }}
                                type="email"
                                inputMode="email"
                                placeholder={t('ex: email')}
                                {...(withEditOptional(['email'])({form, onChange}) ?? {})}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    organization_title: {
        title: 'name of the unit/organization',
        children: [
            {
                name: 'organization_name',
                type: 'text',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}, ...props) => {
                        return ({
                            name,
                            defaultValue: value,
                            onChange,
                            placeholder: translate('name of the unit/organization'),
                            ...props
                        })
                    }),
                    pure
                )(Input),
            },

        ],
    },
    address: {
        title: 'address',
        children: [
            {
                name: 'address',
                component: compose(
                    withTranslate,
                    mapProps(({onChange, value, translate}) => ({
                        onChange,
                        defaultValue: value,
                        name: 'address',
                        placeholder: translate('ex: address'),
                        type: 'text',
                    }))
                )(Input),
            },
        ],
    },
    about: {
        title: 'introduce',
        children: [
            {
                name: 'about',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    hashtags: {
        title: 'category tags',
        children: [
            {
                name: 'hashtags',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: LookupTagsPicker,
                    placeholder: 'tags',
                    apiInfo: {
                        root: API_ROOT_URL,
                        path: '/lookup/yellow_page_hashtags/gets',
                        method: 'GET',
                        schema: baseItemSchema,
                        transform: createListTransform(baseItemSchema),
                        paramFields: ['keyword'],
                        fields: ['keyword'],
                    },
                    withProps: ({name, onChange}) => ({
                        onChange: (e, option) => {
                            onChange(createValue(name, e.target.value))
                        },
                    }),
                }),
            },
        ],
    },
}


// Tái dùng thẳng các component field đã có sẵn trong formSchema (LookupField owner/patron_saint/
// contact_user/province, CountryPicker, SlateEditor, LookupTagsPicker...) thay vì viết lại - chỉ
// đổi khung ngoài (Section/Field) cho Create/EditYellowPageForm, cùng pattern đã dùng ở
// ParishForm.js/DioceseForm.js. Xem docs/ui/design-principles.md "Pattern: Inline CRUD trong list".
const OrganizationNameInput = formSchema.organization_title.children[0].component
const OwnerInput = formSchema.owner.children[0].component
const HashtagsInput = formSchema.hashtags.children[0].component
const RoleTitleInput = formSchema.role_title.children[0].component
const PatronSaintInput = formSchema.full_name.children[0].component
const ContactUserInput = formSchema.full_name.children[1].component
const PhoneInput = formSchema.phone_email.children[0].component
const EmailInput = formSchema.phone_email.children[1].component
const AddressInput = formSchema.address.children[0].component
const CountryInput = formSchema.location.children[0].component
const ProvinceInput = formSchema.location.children[1].component
const AboutInput = formSchema.about.children[0].component

const YellowPageSmallIconButton = ({icon, href, onClick, target, title, divider = false}) => (
    <a
        href={href}
        target={target}
        rel={target ? 'noreferrer' : undefined}
        onClick={onClick}
        title={title}
        className={`flex flex-center w-8 h-8 background-200 hover:bg-primary-50 text-color-400 hover:text-primary rounded-full cursor-pointer no-underline flex-shrink-0 ${divider ? 'ml-1 border-l border-color-50 pl-1' : ''}`}>
        {icon}
    </a>
)

export const YellowPageDetailViewForm = ({item, onCancel}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('about')
    const [isEditing, setIsEditing] = useState(false)

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: yellowPage_editYellowPage_Api,
        onSuccess: () => {
            setIsEditing(false)
            onCancel()
        },
    })

    const {
        organization_name,
        organization_role_title,
        contact_name,
        phone, phone2,
        email,
        address,
        province_name,
        district_name,
        ward_name,
        owner,
        hashtags,
        about,
        description,
        coordinate = {},
    } = item ?? {}

    const tags = (hashtags || "").split(",").filter(e => !!e);
    const [primaryTag, ...restTags] = tags
    const {latitude, longitude} = coordinate || {};
    const mapUrl = (latitude && longitude) ? `https://www.google.com/maps?q=${latitude},${longitude}` : null

    const hasContactDetails = _.some([phone, phone2, email])
    const hasLocation = _.some([address, province_name, district_name, ward_name]) || !!mapUrl
    const hasAbout = !isRawContentEmpty(about) || !!description

    const tabs = [
        {key: 'about', label: t('introduce')},
        {key: 'location', label: t('location and map')},
    ]

    if (isEditing) {
        return (
            <EditYellowPageForm
                item={item}
                initialValues={item}
                onCancel={() => setIsEditing(false)}
                onSubmit={(values) => onUpdate(values, {id: item?.id})}
            />
        )
    }

    const ToggleMap = ({preview_url, onClick = NullAsDefault, onRemove = NullAsDefault}) => {
        const t = useTranslate()
        const {isSm} = useContext(LayoutContext)

        const renderMap = useCallback(() => {
            if (preview_url) {
                return (
                    <img
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            objectFit: 'cover',
                        }}
                        className="w-full h-full rounded-lg"
                        src={preview_url}
                        alt={preview_url || ''}
                    />
                )
            } else {
                return (
                    <div className="absolute top-0 left-0 w-full h-full flex flex-center flex-col verticalList">
                        <EnvironmentOutlined
                            style={{
                                fontSize: '4em',
                                color: '#e8e8e8',
                            }}
                        />
                        <Button
                            className="rounded-md no-shadow no-text-shadow no-border"
                            type="primary">
                            {t('add map')}
                        </Button>
                    </div>
                )
            }
        }, [preview_url])

        return (
            <div
                onClick={onClick}
                style={{height: isSm ? 160 : 200}}
                className="w-full border border-color-50 rounded-lg relative">
                {renderMap()}
                {renderIf(
                    !!preview_url && onRemove !== NullAsDefault,
                    <BsTrash
                        style={{
                            position: 'absolute',
                            right: 15,
                            bottom: 15,
                            padding: 5,
                        }}
                        size={25}
                        className="background text-red-300 hover:text-red-600 border border-red-500 rounded cursor-pointer"
                        onClick={(e) => {
                            preventParentEvent(e)
                            onRemove()
                        }}
                    />
                )}
            </div>
        )
    }

    return (
        <div className="flex flex-col gap-3">
            <div
                className="-mx-4 -mt-4 px-4 pt-4 pb-3 flex items-center gap-3"
                style={{background: 'linear-gradient(135deg, var(--color-primary) 0%, #4a1010 100%)'}}>
                <Avatar
                    size={48}
                    src={getAvatar(owner)}
                    icon={<FaIdCard size={22} className="text-white"/>}
                    className="flex flex-center bg-white bg-opacity-20 rounded-xl flex-shrink-0"
                />
                <div className="flex flex-col flex-1 min-w-0">
                    {renderIf(
                        primaryTag,
                        <span
                            className="w-fit px-2 py-0.5 mb-1 bg-white bg-opacity-20 font-bold text-2xs text-white uppercase rounded-full tracking-wider">
                            {primaryTag}
                        </span>
                    )}
                    <div className="font-bold text-base text-white leading-snug max-lines-1">
                        {organization_name}
                    </div>
                    {renderIf(
                        owner,
                        <div className="space-x-1 text-xs italic leading-tight">
                            <span className="text-white text-opacity-70 whitespace-no-wrap italic">
                                {t('created by')}
                            </span>
                            <Link to={getLinkToDetail(owner)} className="font-semibold text-white no-underline">
                                {getTitle(owner)}
                            </Link>
                        </div>
                    )}
                </div>
            </div>

            {renderIf(
                _.some([organization_role_title, contact_name]),
                <ItemInfoWithIcon
                    icon={<FaUserTie size={10} className="text-blue-400"/>}
                    value={_.compact([organization_role_title, contact_name]).join(' ')}
                    className="ml-1 text-xs italic"
                />
            )}

            {renderIf(
                restTags.length > 0,
                <div className="ml-1 flex flex-wrap gap-2">
                    {restTags.map((ee, ii) => (
                        <span key={ii}
                              style={{padding: '2px 8px', fontSize: 10, borderRadius: 999}}
                              className="w-fit border border-primary-300 font-medium text-primary-500 italic leading-tight">
                            {ee}
                        </span>
                    ))}
                </div>
            )}

            <div className="flex items-center justify-end gap-2">
                {renderIf(
                    _.some([phone, phone2]),
                    <YellowPageSmallIconButton
                        icon={<FaPhoneAlt size={13} className="text-green-500"/>}
                        title={t('call now')}
                        href={`tel:${phone || phone2}`}
                    />
                )}
                {renderIf(
                    mapUrl,
                    <YellowPageSmallIconButton
                        icon={<FaDirections size={14} className="text-blue-500"/>}
                        title={t('directions')}
                        href={mapUrl}
                        target="_blank"
                    />
                )}
                <YellowPageSmallIconButton
                    icon={<RiShareForwardFill size={14} className="text-indigo-500"/>}
                    title={t('share')}
                    onClick={(e) => {
                        e.preventDefault()
                        callNativeShare({title: organization_name, url: window.location.href})
                    }}
                />
                {renderIf(
                    item?.edit,
                    <YellowPageSmallIconButton
                        divider={true}
                        icon={<BiSolidEdit size={14} className="text-primary"/>}
                        title={t('edit')}
                        onClick={(e) => {
                            e.preventDefault()
                            setIsEditing(true)
                        }}
                    />
                )}
            </div>

            <div className="flex items-center gap-1 p-1 background-200 rounded-full">
                {tabs.map((tabItem) => (
                    <div
                        key={tabItem.key}
                        onClick={() => setCurrent(tabItem.key)}
                        className={`flex-1 py-1.5 text-center font-semibold text-xs md:text-sm rounded-full cursor-pointer truncate transition-colors ${
                            current === tabItem.key
                                ? 'bg-primary text-white shadow'
                                : 'text-color-400 hover:text-color-000'
                        }`}>
                        {tabItem.label}
                    </div>
                ))}
            </div>

            {current === 'location' && (
                <div className="flex flex-col gap-3">
                    {renderIfElse(
                        hasLocation,
                        <React.Fragment>
                            {renderIf(
                                _.some([address, province_name]),
                                <div className="p-3 border border-color-50 rounded-xl flex flex-col gap-2">
                                    <div className="flex items-start justify-between gap-2">
                                        <span className="flex-1 font-semibold text-sm text-color-100">
                                            {getFullAddress(item)}
                                        </span>
                                        <span
                                            onClick={() => copyLink(_.compact([address, ward_name, district_name, province_name]).join(', '))}
                                            className="flex items-center gap-1 flex-shrink-0 font-medium text-2xs text-color-400 hover:text-primary cursor-pointer">
                                            <MdContentCopy size={12}/>
                                            {t('copy')}
                                        </span>
                                    </div>
                                    {renderIf(
                                        _.some([district_name, province_name]),
                                        <div className="flex flex-wrap gap-2">
                                            {renderIf(
                                                district_name,
                                                <span
                                                    className="px-2 py-0.5 background-200 font-medium text-2xs text-color-400 rounded-full">
                                                    {district_name}
                                                </span>
                                            )}
                                            {renderIf(
                                                province_name,
                                                <span
                                                    className="px-2 py-0.5 background-200 font-medium text-2xs text-color-400 rounded-full">
                                                    {province_name}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                            {renderIfElse(
                                (coordinate?.static_map_url || "").trim().length,
                                <a
                                    href={mapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="custom-toggle-map hover:shadow-out rounded-lg cursor-pointer relative">
                                    <div className="mask-map h-full flex-col flex-center gap-2 rounded-lg absolute z-3">
                                        <SiOpenstreetmap size={40} className="text-white opacity-85"/>
                                        <div className="flex flex-col items-center">
                                            <span style={{color: '#fff'}} className="font-semibold leading-snug">
                                              {t('view map')}
                                            </span>
                                            <span className="text-2xs text-white italic opacity-50 leading-tight">
                                                {t('click to open the map')}
                                            </span>
                                        </div>
                                    </div>
                                    <ToggleMap preview_url={coordinate?.static_map_url}/>
                                </a>,
                                renderIf(
                                    !!latitude && !!longitude,
                                    <LeafletMap {...{latitude, longitude}} />
                                )
                            )}
                        </React.Fragment>,
                        <EmptyHolder/>
                    )}
                </div>
            )}

            {current === 'about' && (
                <div className="flex flex-col gap-3">
                    {renderIfElse(
                        hasContactDetails || hasAbout,
                        <React.Fragment>
                            {renderIf(
                                hasContactDetails,
                                <div className="p-3 border border-color-50 rounded-xl flex flex-col gap-3">
                                    {renderIf(
                                        phone,
                                        <div className="flex items-center justify-between gap-2">
                                            <ItemInfoWithIcon
                                                icon={<FaPhoneAlt size={10} className="text-blue-400"/>}
                                                value={phone}
                                                className="text-xs italic"
                                            />
                                            <a href={`tel:${phone}`}
                                               className="px-2 py-0.5 font-semibold text-2xs text-primary border border-primary rounded-full no-underline">
                                                {t('call')}
                                            </a>
                                        </div>
                                    )}
                                    {renderIf(
                                        phone2,
                                        <div className="flex items-center justify-between gap-2">
                                            <ItemInfoWithIcon
                                                icon={<FaPhoneAlt size={10} className="text-blue-400"/>}
                                                value={phone2}
                                                className="text-xs italic"
                                            />
                                            <a href={`tel:${phone2}`}
                                               className="px-2 py-0.5 font-semibold text-2xs text-primary border border-primary rounded-full no-underline">
                                                {t('call')}
                                            </a>
                                        </div>
                                    )}
                                    {renderIf(
                                        email,
                                        <ItemInfoWithIcon
                                            icon={<FaEnvelope size={10} className="text-blue-400"/>}
                                            value={email}
                                            className="text-xs italic"
                                        />
                                    )}
                                </div>
                            )}
                            {renderIf(
                                hasAbout,
                                <div className="p-3 border border-color-50 rounded-xl" style={{fontSize: 13}}>
                                    {!isRawContentEmpty(about) ? (
                                        <SlateRenderer value={convertFromString(about)}/>
                                    ) : (
                                        <span className="text-sm text-color-100 whitespace-pre-line">{description}</span>
                                    )}
                                </div>
                            )}
                        </React.Fragment>,
                        <EmptyHolder/>
                    )}
                </div>
            )}

        </div>
    )
}

export const CreateYellowPageForm = ({
                                         onCancel = NullAsDefault,
                                         onSubmit = NullAsDefault,
                                     }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        _.forEach(['contact_name'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }
    const initialValues = {
        // owner_type: undefined,
        // owner_id: undefined,
        // owner: undefined,
        // contact_user: undefined,
        contact_name: undefined,
        // prefix_title: undefined,
        // organization_name: undefined,
        // organization_role_title: undefined,
        // address: undefined,
        // country: undefined,
        // country_id: undefined,
        // province_id: undefined,
        // province: undefined,
        // province_name: undefined,
        // phone: undefined,
        // phone2: undefined,
        // email: undefined,
        // about: undefined,
        status: 1
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {hashtags = [], ...rest} = values ?? {}
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        hashtags: !!hashtags ? (hashtags).join(",") : undefined,
                    },
                    _.isUndefined
                ))
            }}>
            {(formik) => {
                const {values, handleSubmit, isSubmitting, isValid, setFieldValue} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                return (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <Section icon={FaIdCard} title={t('name of the unit/organization')}>
                            <OrganizationNameInput name="organization_name" value={values.organization_name} onChange={onChange} form={formik}/>
                        </Section>

                        <Section icon={BiSolidChurch} title={t('organization interlinkages')} subtitle={t('optional')}>
                            <OwnerInput name="owner" value={values.owner} onChange={onChange} form={formik}/>
                        </Section>

                        <Section icon={IoPricetagOutline} title={t('category tags')} subtitle={t('optional')}>
                            <HashtagsInput name="hashtags" value={values.hashtags} onChange={onChange} form={formik}/>
                        </Section>

                        <Section icon={MdContactPhone} title={t('contact')} theme="highlight">
                            <Field label={t('role title')}>
                                <RoleTitleInput name="organization_role_title" value={values.organization_role_title} onChange={onChange} form={formik}/>
                            </Field>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('holy name')}>
                                    <PatronSaintInput name="patron_saint" value={values.patron_saint} onChange={onChange} form={formik}/>
                                </Field>
                                <Field label={t('full name')} required>
                                    <ContactUserInput name="contact_user" value={values.contact_user} onChange={onChange} form={formik}/>
                                </Field>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('phone')}>
                                    <PhoneInput name="phone" value={values.phone} onChange={onChange} form={formik}/>
                                </Field>
                                <Field label={t('email')}>
                                    <EmailInput name="email" value={values.email} onChange={onChange} form={formik}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={RiMapPinFill} title={t('location')} subtitle={t('optional')}>
                            <Field label={t('address')}>
                                <AddressInput name="address" value={values.address} onChange={onChange} form={formik}/>
                            </Field>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('country')}>
                                    <CountryInput name="country_id" value={values.country_id} onChange={onChange} form={formik}/>
                                </Field>
                                <Field label={t('province')}>
                                    <ProvinceInput name="province" value={values.province} onChange={onChange} form={formik}/>
                                </Field>
                            </div>
                        </Section>

                        <FormActions onCancel={onCancel} submitText="create" isSubmitting={isSubmitting} isValid={isValid}/>
                    </form>
                )
            }}
        </Formik>
    )
}

// Component riêng ở module scope cho từng tab của ActionModalWrapper — bắt buộc, vì
// ActionModalWrapper dùng field.component như một React component TYPE (const Component =
// field.component; <Component/>). Nếu định nghĩa inline ngay trong tabs=[...] (bên trong render
// của EditYellowPageForm), mỗi lần Formik re-render (mỗi keystroke) sẽ tạo ra 1 function reference
// mới -> React coi là component type khác -> unmount/remount toàn bộ cây con của tab đang active,
// khiến field hashtags (LookupTagsPicker) bị mount lại liên tục -> gọi lại API lookup liên tục.
const YellowPageEditOverviewTab = ({child}) => child

const YellowPageEditAboutTab = createSlateTab('about', AboutInput, IoBookOutline, 'introduce')

export const EditYellowPageForm = ({
                                       item,
                                       initialValues,
                                       onCancel = NullAsDefault,
                                       onSubmit = NullAsDefault,
                                   }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview')

    const _initialValues = {
        ...initialValues,
        about: convertFromString(_.get(initialValues, 'about')),
    }

    const validate = (values) => {
        let errors = {}
        _.forEach(['contact_name'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({owner, contact_user, country, province, patron_saint, about, hashtags = [], ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        hashtags: !!hashtags ? (hashtags).join(",") : undefined,
                        about: about ? convertToString(about) : undefined,
                    },
                    _.isUndefined
                ))
            }}>
            {(formik) => {
                const {values, setFieldValue} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                const overviewContent = (
                    <div className="flex flex-col gap-4">
                        <Section icon={FaIdCard} title={t('name of the unit/organization')}>
                            <OrganizationNameInput name="organization_name" value={values.organization_name} onChange={onChange} form={formik}/>
                        </Section>

                        <Section icon={BiSolidChurch} title={t('organization interlinkages')} subtitle={t('optional')}>
                            <OwnerInput name="owner" value={values.owner} onChange={onChange} form={formik}/>
                        </Section>

                        <Section icon={IoPricetagOutline} title={t('category tags')} subtitle={t('optional')}>
                            <HashtagsInput name="hashtags" value={values.hashtags} onChange={onChange} form={formik}/>
                        </Section>

                        <Section icon={MdContactPhone} title={t('contact')} theme="highlight">
                            <Field label={t('role title')}>
                                <RoleTitleInput name="organization_role_title" value={values.organization_role_title} onChange={onChange} form={formik}/>
                            </Field>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('holy name')}>
                                    <PatronSaintInput name="patron_saint" value={values.patron_saint} onChange={onChange} form={formik}/>
                                </Field>
                                <Field label={t('full name')} required>
                                    <ContactUserInput name="contact_user" value={values.contact_user} onChange={onChange} form={formik}/>
                                </Field>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('phone')}>
                                    <PhoneInput name="phone" value={values.phone} onChange={onChange} form={formik}/>
                                </Field>
                                <Field label={t('email')}>
                                    <EmailInput name="email" value={values.email} onChange={onChange} form={formik}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={RiMapPinFill} title={t('location')} subtitle={t('optional')}>
                            <Field label={t('address')}>
                                <AddressInput name="address" value={values.address} onChange={onChange} form={formik}/>
                            </Field>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('country')}>
                                    <CountryInput name="country_id" value={values.country_id} onChange={onChange} form={formik}/>
                                </Field>
                                <Field label={t('province')}>
                                    <ProvinceInput name="province" value={values.province} onChange={onChange} form={formik}/>
                                </Field>
                            </div>
                        </Section>
                    </div>
                )

                return (
                    <ActionModalWrapper
                        tab={current}
                        tabPosition="top"
                        action={<FormActionBar submitText="save"/>}
                        onTabChange={(key) => {
                            setCurrent(key)
                        }}
                        tabs={[
                            {
                                key: 'overview',
                                label: 'overview',
                                component: YellowPageEditOverviewTab,
                            },
                            {
                                key: 'about',
                                label: 'introduce',
                                component: YellowPageEditAboutTab,
                            },
                        ]}>
                        {overviewContent}
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}